/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 1ecde6a338d5
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * Delivery types for assets fetched from third-party platforms.
 */
export const SocialDeliveryType = {
  Facebook: "facebook",
  Twitter: "twitter",
  TwitterName: "twitter_name",
  Instagram: "instagram",
  InstagramName: "instagram_name",
  Gravatar: "gravatar",
  Youtube: "youtube",
  Hulu: "hulu",
  Vimeo: "vimeo",
  Animoto: "animoto",
  Dailymotion: "dailymotion",
  Worldstarhiphop: "worldstarhiphop",
} as const;
/**
 * Delivery types for assets fetched from third-party platforms.
 */
export type SocialDeliveryType = ClosedEnum<typeof SocialDeliveryType>;

export const SocialDeliveryType$zodSchema = z.enum([
  "facebook",
  "twitter",
  "twitter_name",
  "instagram",
  "instagram_name",
  "gravatar",
  "youtube",
  "hulu",
  "vimeo",
  "animoto",
  "dailymotion",
  "worldstarhiphop",
]).describe("Delivery types for assets fetched from third-party platforms.");
